import axios from "axios";

export const CarouselAPI = {
  carousel: function (limit = 9999) {
    return axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_URL}/carousels/getall-carousels`,
      params: {
        limit: limit,
      },
    });
  },
};
